






import { Component, Mixins, Prop } from "vue-property-decorator";
import { Document } from "../../domain/document";
import { DocumentProcessor } from "../document/editors";
import { BackgroundView } from "../system";
import { DocumentParameterContainableMixin, DocumentsRegisterViewMixin } from "./mixins";

@Component({
  components: {
    BackgroundView,
    DocumentProcessor,
  },
})
export default class ExistingDocumentRegisterView extends Mixins(DocumentsRegisterViewMixin, DocumentParameterContainableMixin) {
  @Prop()
  documentId: number;

  @Prop({ default: true })
  shouldRegisterChainedDocumentOnly: boolean;

  $refs!: {
    processor: DocumentProcessor,
  };

  async mounted(): Promise<void> {
    try {
      this.$registerCloseHandler(this.deleteEditToken);
      await this.start(this.registerStartMessage);
      await this.$refs.processor.processDocument(await this._processDocument());
      await this.finish(this.registerFinishMessage);
    } catch (e) {
      await this.fatal(e.message, e);
    }
  }

  get registerStartMessage(): string {
    return this.shouldRegisterChainedDocumentOnly
      ? "該当文書の連鎖先文書を登録します。連鎖元文書Id: " + this.documentId
      : "既存の該当文書を更新します。文書Id: " + this.documentId;
  }

  get registerFinishMessage(): string {
    return this.shouldRegisterChainedDocumentOnly
      ? "該当文書の連鎖先文書を登録しました。連鎖元文書Id: " + this.documentId
      : "既存の該当文書を更新しました。文書Id: " + this.documentId;
  }

  async _processDocument(): Promise<Document> {
    return this.loadInitializedExistingDocument(this.patientNo, this.documentId, this.orderNo, this.parameterContainer);
  }

  async deleteEditToken(): Promise<void> {
    await this.deleteDocumentEditTokens(this.editTokenWithChainDocument);
  }
}
